import styled from "styled-components";
import * as React from "react";
import { Row } from "security-app/components/common/FormBaseStyles";
import { Button } from "components/bootstrap";
const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const DefinitionFormControls = ({
  action,
  activeStepIndex,
  onCancel,
  onOpenNextPage,
  onOpenPrevPage,
  onSubmit,
  steps
}) => /* @__PURE__ */ React.createElement(ButtonsRow, null, /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "0.5rem" }, activeStepIndex > 0 && /* @__PURE__ */ React.createElement(Button, { onClick: onOpenPrevPage, disabled: activeStepIndex === 0 }, "Previous"), /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel")), /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "0.5rem" }, activeStepIndex < steps.length - 1 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { onClick: onSubmit }, "Save changes"), /* @__PURE__ */ React.createElement(Button, { onClick: onOpenNextPage }, "Next")) : /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onSubmit }, action === "edit" ? "Update" : "Create", " event definition")));
export default DefinitionFormControls;
